import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import LOOKUP from 'constants/lookup';
import CardSimple from 'screens/components/basic/CardSimple';
import { getGiftCardBalance, getCsvReport } from 'actions/ReportsAction';
import { formInput, clearFormInput } from 'actions/FormActions';
import Pagination from 'screens/components/basic/Pagination';
import PageHeader from 'screens/components/basic/PageHeader';
import { reportGiftCardRBalanceCrumb } from 'utils/breadcrumbInfo';
import Grid from 'screens/components/basic/Grid';
import { showError } from 'actions/CommonActions';
import WithRouter from 'custom/withRouter';
import Body from './Body';
import Header from './Header';
class GiftCardBalance extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activePage: 1,
            itemsPerPage: 20,
            showBody: false,
            totalRow: 0,
            model: {
                beginDate: 0,
                endDate: 0,
                branch: 0
            }
        };
        this.showBody = this.showBody.bind(this)
    }
    componentWillMount() {
        const date = new Date();
        this.props.formInput(date, `giftCardBalanceEndDate`);
    }
    downloadReport = () => {
        const endDate = this.props.endDate ? moment(this.props.endDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        const branchIds = this.props.selectedBranches ? [...this.props.selectedBranches].sort((a, b) => a - b) : [];
        this.props.getCsvReport(`reports/excel/GiftCardBalance?endDate=${endDate}&branchIds=${branchIds}`, "giftcardBalance");
    }
    changePage = (e) => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: e
            };
        }, this.getReport);
    }
    filter = () => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getReport);
    }
    getReport = () => {
        const endDate = this.props.endDate ? moment(this.props.endDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        
        const branchIds = this.props.selectedBranches ? [...this.props.selectedBranches].sort((a, b) => a - b) : [];
        const pageNumber = this.state.activePage;
        const pageSize = this.state.itemsPerPage;
        console.log( this.props.getGiftCardBalance({ endDate, branchIds, pageNumber, pageSize }))
        this.props.getGiftCardBalance({ endDate, branchIds, pageNumber, pageSize });
    }
    showBody() {
        this.filter();
        this.setState({ showBody: true });
    }
    redirectToReport = () => {
        this.props.navigate("/report");
    }
    componentWillReceiveProps = (newProps) => {
        if (this.state.showBody) {
            const totalRow = newProps.giftCardBalance && newProps.giftCardBalance.list && newProps.giftCardBalance.list.length > 0 ? newProps.giftCardBalance.total : 0;
            this.setState({ totalRow: totalRow });
        }
    }
    render() {
        return (
            <Grid headerContent={reportGiftCardRBalanceCrumb}>
                <PageHeader title={LOOKUP.report.giftCardBalance.text}
                    description={LOOKUP.report.giftCardBalance.description}
                />
                <Header
                    branchOptions={this.props.branchOptions}
                    filter={this.filter}
                    download={this.downloadReport}
                    showBody={this.showBody}
                    loggedBranch={this.props.loggedBranch}
                />
                {
                    this.state.showBody &&
                    <p className="text-right mt-2 blue-text">
                        <i>Generated on : {moment().format('MMMM Do YYYY, h:mm:ss a')}</i>
                    </p>
                }
                {
                    this.state.showBody && this.props.giftCardBalance && this.props.giftCardBalance.list &&
                    <CardSimple>
                        <Body
                            branchOptions={this.props.branchOptions}
                            giftCardBalance={this.props.giftCardBalance}
                            endDate={this.props.endDate}
                            loggedBranch={this.props.loggedBranch}
                            branchForm={this.props.branch}
                        />
                        <Pagination
                            length={this.state.totalRow}
                            itemsPerPage={this.state.itemsPerPage}
                            activePage={this.state.activePage}
                            onPageChange={this.changePage}
                        />
                    </CardSimple>
                }
            </Grid>
        );
    }
}
const mapStateToProps = state => {
    let branches = state.common.userBranches || [];
    let branchOptions = [];
    branches.map((item) => {
        branchOptions.push({
            text: item.name, value: item.id.toString()
        });
    })
    return {
        branchOptions: branchOptions,
        giftCardBalance: state.reports.giftCardBalance || [],
        loggedBranch: state.common.branchId,
        selectedBranches: state.form[`GiftCardBalanceBranches`],
        endDate: state.form[`GiftCardBalanceEndDate`],
        branch: state.form.giftCardBalanceBranchOption
    };
};
const mapDispatchToProps = dispatch => {
    return {
        getGiftCardBalance: model => dispatch(getGiftCardBalance(model)),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        showError: (message) => dispatch(showError(message)),
        formInput: (value, name) => dispatch(formInput(value, name)),
        getCsvReport: (url, name) => dispatch(getCsvReport(url, name))
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(GiftCardBalance));